import createReactComponent from '../createReactComponent';
export default createReactComponent('heart-discount', 'IconHeartDiscount', [
  [
    'path',
    {
      d: 'M13 19l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M16 21l5 -5', key: 'svg-1' }],
  ['path', { d: 'M21 21v.01', key: 'svg-2' }],
  ['path', { d: 'M16 16v.01', key: 'svg-3' }],
]);
